import { Injectable } from '@angular/core';

import { AI_CONVERSATION_ROLES } from 'src/app/constants';
import { SavedReportDateRange } from 'src/models/index';

import { ApiService } from './api.service';
import { AuthService } from './auth.service';

export interface AnalyticsAssistantMessage {
  role: typeof AI_CONVERSATION_ROLES.USER | typeof AI_CONVERSATION_ROLES.ASSISTANT;
  content: string;
}

export interface AnalyticsRequest {
  timezone?: string;
  dateRange?: SavedReportDateRange;
  startDate?: string;
  endDate?: string;
  dateDimension: string;
  metric: string;
  dimensions?: string[];
  filters?: Record<string, unknown>;
}

export interface AnalyticsAssistantRequest {
  history: AnalyticsAssistantMessage[];
  currentAnalyticsContext: AnalyticsRequest;
  timeSeriesData?: any; // Chart data that the user is currently viewing
}

@Injectable({ providedIn: 'root' })
export class AnalyticsAssistantService {
  constructor(
    private apiService: ApiService,
    private authService: AuthService,
  ) {}

  isFeatureEnabled() {
    return this.authService.tenant.featureFlags?.ANALYTICS_ASSISTANT === true;
  }

  async sendMessage(request: AnalyticsAssistantRequest): Promise<AnalyticsAssistantMessage[]> {
    if (!this.isFeatureEnabled()) {
      throw new Error('Analytics assistant feature is not enabled');
    }

    return this.apiService.postPromise('/analytics-assistant', request);
  }
}
